import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
    Button,
    Grid,
} from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import SeaServiceMMCPaymentThankYouPage from 'pages/SeaServiceMMCPaymentThankYouPage';
import Show from 'components/utils/Show';

const useStyles = makeStyles(theme => ({
    buttonContainer: {
        margin: '1em auto',
        textAlign: 'center',
    },
    button: {
        fontWeight: 'strong',
        color: theme.palette.getContrastText(theme.palette.primary.main),
        backgroundColor: theme.palette.primary.main,
    },
}));

const ApplicationThankYou = ({showClose}) => {
    const classes = useStyles();

    return [
        <SeaServiceMMCPaymentThankYouPage />,
        <Show condition={showClose}>
            <Grid item className={classes.buttonContainer}>
                <Button
                    variant='contained'
                    component={NavLink}
                    to='/applications'
                    className={classes.button}
                >
                    Close
                </Button>
            </Grid>
        </Show>
    ];
};

export default ApplicationThankYou;
